
import type { PropType } from 'vue'
import type { Params } from '../abstract.component'
import type { Config, Data } from '../radar-chart/radar-chart.component'
import { defineComponent } from 'vue'
import { RadarChartComponent as Component } from '../radar-chart/radar-chart.component'

export default defineComponent({
  name: 'RadarChart',
  props: {
    params: Object as PropType<Params<Config, Data>>,
  },
  data() {
    return {
      component: undefined,
    }
  },
  computed: {
    componentParams(): Params<Config, Data> {
      return {
        config: {
          ...this.params.config,
          locale: this.$epb.locale,
        },
        data: this.params.data,
      }
    },
  },
  watch: {
    componentParams(componentParams: Params<Config, Data>): void {
      this.component.update(componentParams)
    },
  },
  mounted(): void {
    this.component = new Component(this.$el, this.componentParams)
  },
  beforeDestroy(): void {
    this.component.destroy()
  },
})
